<div class="container text-center py-4">
  <p class="text-center small">
    Finding the best trains for you
  </p>
  <div class="station-holder d-flex justify-content-between align-items-center text-dark">
    <p class="small mb-0">
      {{searchParams?.sourceAbbreviation}}
    </p>
    <img src="../../assets/social media assets/footer-logo.svg" alt="logo"
      class="logo transform-rotate-90">
    <p class="small mb-0">
      {{searchParams?.destinationAbbreviation}}
    </p>
  </div>
  <p class="text-center small">
    {{searchParams?.date | date : 'mediumDate'}}
  </p>
  <p class="text-center small">
    {{searchParams?.price}}, {{searchParams?.passenger}} Passengers
  </p>
  <p><ngb-progressbar type="info" [animated]="true" height="3px" [value]="timer"></ngb-progressbar></p>
</div>
